import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { AccountApi, LoginResultViewModel, LoginViewModel } from "@/openapi";
import store from "@/store";
import { useRouter, useRoute } from "vue-router/composables";

export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const aoi = new AccountApi(undefined, "");
const showPassword = ref(false);
const username = ref("");
const password = ref("");
const loggingIn = ref(false);
const loginResult = ref<LoginResultViewModel | null>(null);
const observer = ref<InstanceType<typeof ValidationObserver>>();
const router = useRouter();
const route = useRoute();

const login = () => {
  if (loggingIn.value) {
    return;
  }

  observer.value?.validate().then((success: boolean) => {
    if (!success) {
      return;
    }

    loggingIn.value = true;

    const loginVm: LoginViewModel = {
      username: username.value,
      password: password.value,
    };

    aoi
      .login(loginVm)
      .then((response) => {
        if (response.data.success) {
          store.commit("setLoggedIn");
          router.push({ path: (route.query.next as string) || "/" });
        } else {
          loginResult.value = response.data;
        }
        loggingIn.value = false;
      })
      .catch(() => {
        loggingIn.value = false;
      });
  });
};

return { __sfc: true,aoi, showPassword, username, password, loggingIn, loginResult, observer, router, route, login, ValidationObserver, ValidationProvider }
}

})